import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { connect } from "react-redux";
import { createSession, emailConfirm } from '../../RestUtil.js';
import Logo from "../../assets/images/logo-white.svg";

function EmailConfirm() {
    // const { token } = useParams();
    const [token, setToken] = useState(null);
    const [tokenVerified, setTokenVerified] = useState(false);
    
    useEffect(() => {
      console.log("window.location",window.location);
      const pathname = window.location.href;
      console.log("href",pathname);
      const lastPathSegment = pathname.substring(pathname.lastIndexOf('/') + 1);
      if (lastPathSegment) {
        setToken(lastPathSegment);
        console.log("now setting token as ",lastPathSegment);
      }
    }, []);

    useEffect(() => {
      if (token) {
         console.log("Obtained Token as ",token);
         createSession().then(resp => {
          console.log("Response",resp);
          let sessionId = resp.id;
          console.log("Session Id",sessionId);
          emailConfirm(sessionId, token).then(resp => {
            console.log("emailConfirm sucess",resp);
            setTokenVerified(true);
            // window.location = "login";
            document.getElementById("verifyMsgSpan").innerHTML = "success"; 
            document.getElementById("verifyMsgSpan").style.color = "blue";
          })
          .catch(err => {
            console.log("emailConfirm failed",err.response.data);       
            document.getElementById("verifyMsgSpan").innerHTML = err.response.data; 
            document.getElementById("verifyMsgSpan").style.color = "red";
          });      
        });
  

      }
    }, [token]);
    return (
      <div className="theme-cyan">
        <div >
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                  <img src="images/logo.png" width="48" height="48" alt="Lucid" />
                </div>
                <div className="card">
                  <div className="header">
                    <p className="lead">Email Confirmation</p>
                  </div>
                  {!tokenVerified &&
                  <div className="body">
                    <span id="verifyMsgSpan">Your email is being verified...it will take few seconds...!</span>
                  </div>
                  }
                  {tokenVerified &&
                  <div className="body">
                    <span style={{cursor:"pointer",color:"blue"}} onClick={() => {
                       window.location = "login";
                    }}
                    >Thanks for your confirmation, now you are all set. <u>Please click here to login</u></span>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

export default EmailConfirm;